// extracted by mini-css-extract-plugin
export var expContainer = "experienceTwo-module--expContainer--a4ccG";
export var experienceBg = "experienceTwo-module--experienceBg---cYFE";
export var expBotText = "experienceTwo-module--expBotText--1eLOV";